import type { OddsFormat } from '@pickpro/contracts';
import { formatNumber } from './format-number';

const TWO_DECIMALS = { minimumFractionDigits: 2, maximumFractionDigits: 2 } as const;
const DENOMINATOR_LIMIT = 100;
const CONVERGENT_STEPS = 32;
const EXHAUSTED = 1e-9;

const approximate = (value: number): readonly [number, number] => {
  let previous: readonly [number, number] = [0, 1];
  let current: readonly [number, number] = [1, 0];
  let rest = value;
  for (let step = 0; step < CONVERGENT_STEPS; step += 1) {
    const whole = Math.floor(rest);
    const next = [whole * current[0] + previous[0], whole * current[1] + previous[1]] as readonly [
      number,
      number,
    ];
    if (next[1] > DENOMINATOR_LIMIT) break;
    previous = current;
    current = next;
    const fraction = rest - whole;
    if (fraction < EXHAUSTED) break;
    rest = 1 / fraction;
  }
  return current;
};

export const formatPrice = (decimal: number, format: OddsFormat, locale: string): string => {
  const edge = decimal - 1;
  if (format === 'decimal' || edge <= 0) return formatNumber(decimal, locale, TWO_DECIMALS);
  if (format === 'american')
    return decimal >= 2 ? `+${Math.round(edge * 100)}` : `-${Math.round(100 / edge)}`;
  const [numerator, denominator] = approximate(edge);
  return `${numerator}/${denominator}`;
};
